(function() {
    'use strict';
    angular.module('wbDashboard').factory('User',
             ['$q', '$filter', 'Request', 'Track', 'Upload', 'Auth',
    function ($q, $filter, Request, Track, Upload, Auth) {
        var user = {
                'wbBeta': false
            },
            userData = {
                'overview': null,
                'detail': null,
                'activityComplete': null,
                'activityPending': null,
                'activityResult': null,
                'accounts': null,
                'performance': null,
                'milestonesAll': null,
                'milestonesGood': null,
                'walletMS': null,
                'msPositions': null,
                'msHistory': null,
                'msFuture': null,
                'futureGraph': null,
                'msFundingActivity': null,
                'tradeHistory': null,
                'bankAccounts': null,
                'bankPlaidLogo': null,
                'prospectus': null,
                'documents': null,
                'documentRequests': null,
                'uploadedDocuments': null,
                'referrals': null,
                'invites': null,
            },
            promises = {
                overview: null
            },
            testData,
            testing= true;

        /**
         * Returns entire userdata object
         */
        user.getUserData = function() {
            return user.get();
        };

        /**
         * Get specific userData key
         * @param type
         * @returns {*}
         */
        user.get = function (type) {
            if (!type) {
                return userData;
            } else {
                return userData[type];
            }
        };
        /**
         * Clear any userData key or entire object
         * @param type
         * @returns {boolean}
         */
        user.clear = function (type) {
            if (type) {
                if (!(type in userData)) {
                    throw new Error("UserService: Invalid type in userData");
                }
                userData[type] = null;
            } else {
                Object.keys(userData).forEach(function(key) {
                    userData[key] = null;
                });
            }
            return true;
        };
        /**
         * Manually update any particular data in any userData key
         * @param type
         * @param data
         */
        user.manualSet = function(type, data) {
            if (!(type in userData)) {
                throw new Error("UserService: Invalid type in userData");
            }
            userData[type] = userData[type] || {};
            userData[type] = angular.extend(userData[type], data);
        };

        user.getOverview = function () {
            return user.get('overview');
        };
        user.getOverviewAccounts = function(search) {
            var overview = user.get('overview');
            var account = null;
            if (overview) {
                if (search) {
                    account = $filter('filter')(overview.account_overview, {account_number: search}, true)[0];
                    if (!account) {
                        account = $filter('filter')(overview.account_overview, {type: search}, true)[0];
                    }
                }
                if (!account) {
                    account = overview.account_overview;
                }
            }
            return account;
        };
        promises.overview = $q.defer();
        user.retrieveOverview = function (refresh) {
            if (user.get('overview') && !refresh) {
                return $q.when(user.get('overview'));
            } else {
                return Request.make("user_overview").then(function (response) {
                    userData.overview = response.data.response;

                    Track.gtm({'userId': userData.overview.user.user_code});

                    userData.overview.pending_initial_account = !!userData.overview.account_overview.length;
                    userData.overview.pending_account = null;
                    userData.overview.pending_account_for_bank = null;

                    if (userData.overview.user.is_closed) {
                        userData.overview.pending_initial_account = false;
                    }
                    try {
                        angular.forEach(userData.overview.account_overview, function (account) {
                            //make it match newer account formats
                            account.name = account.full_description;
                            account.type = account.type.toLowerCase().replace(/[\(\)]/g, "").replace(/ /g,"-");
                            account.bank_status = account.bank_account_link_status;
                            delete account.full_description;

                            account.is_ira = account.type.includes("ira");

                            if (account.is_pending) {
                                userData.overview.pending_account = account;
                            } else {
                                //not pending if there are any accounts not pending
                                userData.overview.pending_initial_account = false;
                            }

                            // determine if there's any account that would require ACH
                            if (( !["active", "inactive"].includes(account.bank_status.toLowerCase()) )
                                || ( account.bank_status.toLowerCase() === "inactive" && userData.overview.account_overview.length === 1)
                            ) {
                                userData.overview.pending_account_for_bank = account;
                            }

                        });
                    } catch (err) { }
                    userData.overview.user.annual_income *= 1;

                    try {
                        //will only work once on first retrieval since promise is never recreated
                        promises.overview.resolve(userData.overview);
                    } catch (err) {}

                    return userData.overview;
                });
            }
        };
        /**
         * Promise returned may or may not already be resolved, should be used as a return promise to wait for next state
         * @returns {*}
         */
        user.getOverviewPromise = function() {
            return promises.overview.promise;
        };

        user.getDetail = function () {
            return user.get('detail');
        };
        user.retrieveDetail = function (refresh) {
            if (user.get('detail') && !refresh) {
                return $q.when(user.get('detail'));
            } else {
                return Request.make("user_detail").then(function (response) {
                    userData.detail = response.data;
                    return userData.detail;
                });
            }
        };
        user.updateDetail = function (data) {
            Track.send("Updated Profile", "User updated some data in their profile");

            return Request.make("user_update", {
                detail: data.detail,
                employer: data.employer,
                affiliated_company: data.affiliated_company,
                //permission_token: token
            }).then(function(response) {
                userData.detail = response.data;
                return userData.detail;
            });
        };

        /**
         *
         * @param {Object} data
         * @param {string} data.chosen
         * @returns {*}
         */
        user.updateRiskScore = function (riskScore) {
            return Request.make('user_risk_update', {chosen: riskScore}).then(function(response) {
                return response.data;
            });
        };

        user.getNewPerformance = function () {
            return user.get('newPerformance');
        };
        user.retrieveNewPerformance = function (refresh) {
            if (user.get('newPerformance') && !refresh) {
                return $q.when(user.get('newPerformance'));
            } else {
                return Request.make("user_new_performance").then(function (response) {
                    userData.newPerformance = response.data;

                    angular.forEach(userData.newPerformance.values, function(value) {
                        value.account_value = value.value;
                        value.x = new Date(value.date).getTime();
                        value.y = value.value;
                    });

                    return userData.newPerformance;
                });
            }
        };

        user.retrieveEmailPreferences = function () {
            return Request.make("user_email_preferences").then(function (response) {
                return response.data.response.categories;
            });
        };
        user.updateEmailPreferences = function (categories) {
            var data = {
                categories: categories
            };
            return Request.make('user_email_preferences_update', data).then(function(response) {
                return response.data.response.categories;
            });
        };


        /**
         * returns array of all common milestones
         * or a milestone whose msId matches
         * (needs to return wallet for retrieveMS method
         * @param {string} msId
         * @param {boolean} includeDeleted
         * @returns {*}
         */
        user.getMilestones = function (msId, includeDeleted = false) {
            var milestonesAll = user.get('milestonesAll');
            var milestonesGood = user.get('milestonesGood');
            var walletMS = user.get('walletMS');

            if (msId && walletMS && msId === walletMS.id) {
                return walletMS;
            } else if (msId && milestonesAll && msId in milestonesAll) {
                return milestonesAll[msId];
            } else if (msId || !milestonesAll) {
                //if accountNumber is not null, but doesn't exist
                return null;
            } else if (!msId) {
                if (includeDeleted) {
                    return milestonesAll;
                } else {
                    return milestonesGood;
                }
            }
        };
        user.getMSandWallet = function() {
            var milestonesAll  = user.get('milestonesAll');
            var walletMS = user.get('walletMS');

            if (walletMS) {
                walletMS = {[walletMS.id]: walletMS};
            }

            //shallow copy so both retain their original objects
            var both = angular.extend({}, walletMS, milestonesAll);

            return both;
        };

        /**
         * returns the first milestone of "type"
         * useful for milestones of which there can only be one of
         * eg. retirement, rainy day, wallet
         * @param type
         * @returns {*}
         */
        user.getMilestoneByType = function (type) {
            var milestonesAll = user.get('milestonesAll');
            var milestone = null;
            if (type === 'wallet') {
                return user.get('walletMS');
            }
            angular.forEach(milestonesAll, function(ms) {
                if (!milestone && ms.type_real === type) {
                    milestone = ms;
                }
            });
            return milestone;
        };
        /**
         * returns only the wallet milestone
         * @returns {*}
         */
        user.getWalletMS = function() {
            return user.get('walletMS');
        };

        /**
         * returns a single milestone from server in a promise
         * that's been retrieved before since it needs the id to retrieve
         * @param msId
         * @param refresh
         * @returns {Promise}
         */
        user.retrieveMilestones = function (msId, refresh, clearData = true) {
            if (user.getMilestones(msId) && !refresh) {
                return $q.when(user.getMilestones(msId));
            } else {
                return Request.make("milestone", {msId:msId}).then(function (response) {
                    /* jshint expr: true */
                    userData.milestonesAll || (userData.milestonesAll = {});
                    userData.milestonesGood || (userData.milestonesGood = {});

                    var milestone = response.data;
                    if (clearData) {
                        user.removeMilestoneData(msId);
                    }

                    setMilestoneFormat(milestone);
                    setMilestoneOverviewMetrics(milestone);

                    if (milestone.type === 'wallet') {
                        userData.walletMS = milestone;
                    } else {
                        userData.milestonesAll[msId] = milestone;
                        if (milestone.status === 200) {
                            userData.milestonesGood[msId] = milestone;
                        }
                    }

                    return milestone;
                });
            }
        };
        /**
         * retrieves the wallet milestone if it's been retrieved before
         * since it needs the id to retrieve it
         * @param refresh
         * @returns {Promise}
         */
        user.retrieveWalletMS = function(refresh) {
            var walletMS = user.getWalletMS() || {};
            return user.retrieveMilestones(walletMS.msId, refresh);
        };
        user.retrieveAllMilestones = function (refresh, clearAllData) {
            if (user.retrieveAllMilestones.called && !refresh) {
                return $q.when(user.getMilestones());
            } else {
                user.retrieveAllMilestones.called = true;
                var milestonesAll;
                return Request.make("milestones").then(function (response) {
                    //clear all existing milestones
                    userData.milestonesAll = {};
                    userData.milestonesGood = {}; //only clearing use in getMilestones

                    milestonesAll = response.data.milestones;
                    if (clearAllData) {
                        user.removeAllMilestoneData();
                    }

                    angular.forEach(milestonesAll, function (ms) {
                        setMilestoneFormat(ms);
                        if (ms.type === 'wallet') {
                            userData.walletMS = ms;
                        } else {
                            userData.milestonesAll[ms.id] = ms;
                            if (ms.status === 200) {
                                userData.milestonesGood[ms.id] = ms;
                            }
                        }
                    });

                    //return promise that won't be resolved till overview is run at least once
                    return promises.overview.promise;
                }).then(function () {
                    //update after overview has been completed at least once
                    angular.forEach(userData.milestonesAll, function (ms) {
                        //since milestonesGood is a subset of milestonesAll, it will be updated as well
                        //requires overview
                        setMilestoneOverviewMetrics(ms);
                    });
                    if (userData.walletMS) {
                        setMilestoneOverviewMetrics(userData.walletMS);
                    }
                    return userData.milestonesGood;
                });
            }
        };
        function setMilestoneFormat(ms) {

            ms.extra = {};

            //convert strings to integers
            angular.forEach(ms.metadata, function(metadata, key) {
                if (["life_expectancy", "retirement_age", "social_security_age", "social_security_payout", "purchase_price",
                        "spend_per_year", "months_to_goal", "recommendation"].includes(key)) {
                    ms.metadata[key] *= 1;
                }
            });

            if (!ms.metadata.months_to_goal) {
                ms.metadata.months_to_goal = Math.round(moment(ms.metadata.target_date).diff(moment(new Date()), "months", true));
            }

            ms.allocation.allocation_slug = null;
            if (ms.allocation.allocation_model.length > 4) {
                //must be a uuid, not a score, so set allocation portfolio slug
                ms.allocation.allocation_slug = ms.allocation.allocation_model;
            }

            if (ms.target_amount && ms.metrics.value >= ms.target_amount) {
                ms.complete = true;
            }

            ms.type_real = ms.type;
            if (ms.type === "retirement_shared") {
                ms.type = "retirement";
            }

            ms.type_account = !['build_wealth', 'rainy_day', 'cash', 'custom', 'retirement', 'new_home', 'new_car', 'wallet'].includes(ms.type);

        }
        //metrics that require overview
        function setMilestoneOverviewMetrics(ms) {
            ms.metrics.est_years = ms.metrics.estimated_achievement ? Math.round(Math.abs(moment(new Date()).diff(ms.metrics.estimated_achievement, "years", true))*10)/10 : null;
            ms.metrics.est_age = ms.metrics.estimated_achievement ? Math.abs(moment(user.getOverview().user.birth_date).diff(ms.metrics.estimated_achievement, "years")) : null;

            ms.metrics.target_years = ms.metadata.target_date ? Math.round(Math.abs(moment(new Date()).diff(ms.metadata.target_date, "years", true))*10)/10 : null;
            ms.metrics.target_age = ms.metadata.target_date ? Math.abs(moment(user.getOverview().user.birth_date).diff(ms.metadata.target_date, "years")) : null;
        }

        /**
         * clear various milestone data: positions, history, future graph
         */
        user.removeAllMilestoneData = function (msId) {
            userData.msFuture = userData.msHistory = userData.msPositions = null;
        };
        user.removeMilestoneData = function (msId) {
            if (userData.msFuture) delete userData.msFuture[msId];
            if (userData.msHistory) delete userData.msHistory[msId];
            if (userData.msPositions) delete userData.msPositions[msId];
        };
        user.clearMilestone = function (msId) {
            delete userData.milestonesAll[msId];
            delete userData.milestonesGood[msId];
        };


        user.getMilestonePositions = function (msId) {
            var msPositions = user.get('msPositions');
            if (msId && msPositions && msId in msPositions) {
                return msPositions[msId];
            } else if (msId || !msPositions) {
                //if accountNumber is not null, but doesn't exist
                return null;
            } else if (!msId) {
                return msPositions;
            }
        };
        user.retrieveMilestonePositions = function (msId, refresh) {
            if (user.getMilestonePositions(msId) && !refresh) {
                return $q.when(user.getMilestonePositions(msId));
            } else {
                return Request.make("milestone_positions", {msId:msId}).then(function (response) {
                    var positions = response.data.response;

                    if (positions && Array.isArray(positions.milestone_accounts)) {
                        positions.milestone_accounts.forEach(function (ma) {
                            ma.account_name = ma.account_type.replace("Investment ", "");
                            ma.account_type = ma.account_type.toLowerCase().replace(/[\(\)]/g, "").replace(/ /g, "-");
                        });
                    }

                    /* jshint expr: true */
                    userData.msPositions || (userData.msPositions = {});

                    userData.msPositions[msId] = positions;
                    return userData.msPositions[msId];
                }).catch(function(response) {
                    if (0 && testing) {
                        userData.msPositions || (userData.msPositions = {}); // jshint ignore:line
                        userData.msPositions[msId] = testData.positions;
                        return userData.msPositions[msId];
                    } else {
                        throw response;
                    }
                });
            }
        };

        user.getMilestoneHistory = function (msId) {
            var msHistory = user.get('msHistory');
            if (msId && msHistory && msId in msHistory) {
                return msHistory[msId];
            } else if (msId || !msHistory) {
                //if accountNumber is not null, but doesn't exist
                return null;
            } else if (!msId) {
                return msHistory;
            }
        };
        //note: always refreshes since dates change
        user.retrieveMilestoneHistory = function (msId, data, refresh = true) {
            if (user.getMilestoneHistory(msId) && !refresh) {
                return $q.when(user.getMilestoneHistory(msId));
            } else {
                return Request.make("milestone_history", {msId:msId, start:data.start, end:data.end}).then(function (response) {
                    /* jshint expr: true */
                    var history = response.data.response;

                    history.client.values = history.client.historical_values;

                    angular.forEach(history.client.values, function(value) {
                        value.value = value.close;
                        value.account_value = value.close;

                        //set graph x & y values
                        value.x = new Date(value.date).getTime();
                        value.y = value.value;
                    });

                    history.fresh = !data.start && !data.end;


                    userData.msHistory || (userData.msHistory = {});
                    userData.msHistory[msId] = history;
                    return userData.msHistory[msId];
                });
            }
        };

        user.getFutureGraph = function (msId) {
            var future = user.get('futureGraph');
            if (future) {
                return future[msId];
            } else {
                return null;
            }
        };
        /**
         * @param {Object} data
         * @param {string} data.msId
         * @param {string} data.est_achievement_date
         * @param {boolean} refresh
         * @returns {Promise}
         */
        user.retrieveFutureGraph = function (data, refresh) {
            if (user.getFutureGraph() && !refresh) {
                return $q.when(user.getFutureGraph());
            } else {
                var params = angular.copy(data);
                return Request.make('milestone_future_graph', params).then(function (response) {
                    var future = response.data;

                    future.client.values = future.client.totals;
                    future.client.values.forEach(parseGraphValue);

                    userData.futureGraph || (userData.futureGraph = {}); // jshint ignore:line
                    userData.futureGraph[data.msId] = future;
                    return userData.futureGraph[data.msId];
                });
            }

            function parseGraphValue(value) {
                //make date a full date
                value.date = value.date + "-01";
                value.value = value.value*1;
                value.account_value = value.value;

                //set graph x & y values
                value.x = new Date(value.date).getTime();
                value.y = value.value;
            }

        };

        user.getPerformance = function () {
            return user.get('performance');
        };
        user.retrievePerformance = function (refresh) {
            if (user.getPerformance() && !refresh) {
                return $q.when(user.getPerformance());
            } else {
                return Request.make("user_performance").then(function (response) {
                    var performance = response.data.response;

                    performance.values = performance.historical_values;

                    angular.forEach(performance.values, function(value) {
                        value.value = value.account_value;

                        //set graph x & y values
                        value.x = new Date(value.date).getTime();
                        value.y = value.value;
                    });

                    userData.performance = performance;
                    return userData.performance;
                });
            }
        };


        user.getActivityPending = function () {
            return user.get('activityPending');
        };
        user.retrieveActivityPending = function (refresh) {
            if (user.get('activityPending') && !refresh) {
                return $q.when(user.get('activityPending'));
            } else {
                return Request.make("user_activity_pending").then(function (response) {
                    userData.activityPending = response.data.logs;
                    angular.forEach(userData.activityPending, function(a) {
                        processActivity(a);
                    });
                    return userData.activityPending;
                });
            }
        };



        user.getActivity = function (filters) {
            var hash = JSON.stringify(filters);
            var activityHashes = user.get('activityComplete');

            if (hash && activityHashes) {
                return activityHashes[hash];
            } else if (!activityHashes) {
                return null;
            } else {
                return activityHashes;
            }
        };
        user.retrieveActivity = function (filters, refresh) {
            var hash = JSON.stringify(filters);
            var activity = user.getActivity(filters);
            if (activity && !refresh) {
                return $q.when(activity);
            } else {
                return Request.make("user_activity", filters).then(function (response) {
                    /* jshint expr: true */
                    userData.activityComplete || (userData.activityComplete = {});

                    var activity = response.data;
                    angular.forEach(activity.logs, function(a) {
                        processActivity(a);
                    });
                    userData.activityComplete[hash] = activity;
                    return userData.activityComplete[hash];
                });
            }
        };
        user.getActivityId = function (uuid) {
            if (!uuid) {
                throw new Error("UserService: Activity: getActivityId requires an activity uuid");
            } else {
                var activities, activityHashes;
                var result = null;

                activities = user.get('activityResult');
                if (activities && activities[uuid]) {
                    result = activities[uuid];
                } else {
                    activityHashes = user.get('activityComplete');
                    if (activityHashes) {
                        angular.forEach(activityHashes, function (aH) {
                            angular.forEach(aH.logs, function(a) {
                                if (a.uuid === uuid) {
                                    result = a;
                                }
                            });
                        });
                    }
                }
                return result;
            }
        };
        user.retrieveActivityId = function (uuid, refresh) {
            var a = user.getActivityId(uuid);
            if (a && !refresh) {
                return $q.when(a);
            } else {
                return Request.make("user_activity_id", {uuid: uuid}).then(function (response) {
                    userData.activityResult || (userData.activityResult = {}); // jshint ignore:line

                    var result = response.data;
                    if (response.data.logs) {
                        result = response.data.logs[0];
                    }
                    userData.activityResult[uuid] = processActivity(result);
                    return userData.activityResult[uuid];
                });
            }
        };
        user.clearActivity = function() {
            user.clear('activityComplete');
            user.clear('activityResult');
        };
        function processActivity(a) {
            var date = moment.utc(a.event_at);
            a.event_at = date.local();

            if (a.data && a.data.transaction && a.data.transaction.trade && a.data.transaction.trade.trade_transactions) {
                if (!('amount' in a.data.transaction.trade)) {
                    a.data.transaction.trade.amount = 0;
                    a.data.transaction.trade.sells = 0;
                    a.data.transaction.trade.buys = 0;
                    angular.forEach(a.data.transaction.trade.trade_transactions, function (tt) {
                        if (tt.type === 'buy') {
                            a.data.transaction.trade.buys++;
                        }
                        if (tt.type === 'sell') {
                            a.data.transaction.trade.sells++;
                        }
                        if (!tt.value) {
                            tt.value = tt.price * tt.quantity;
                        }
                        a.data.transaction.trade.amount += tt.value*1;
                    });
                }
            }
            return a;
        }
        user.groupActivityByDate = function(activity) {
            var dateGrouped = {};
            angular.forEach(activity, function(a) {

                var date = moment(a.event_at).format('YYYY-MM-DD');
                if (!dateGrouped[date]) {
                    dateGrouped[date] = [];
                }
                dateGrouped[date].push(a);

            });

            return dateGrouped;
        };

        /**
         * @param {string} type
         * @param {Object} data
         * @param {string} data.uuid
         * @param {string} data.accountNumber
         * @returns {*}
         */
        user.cancelTransaction = function (type, data) {
            var reqUrl;
            switch (type) {
                case 'deposit':
                    reqUrl = 'user_transaction_cancel_deposit';
                    break;
                case 'withdraw':
                    reqUrl = 'user_transaction_cancel_withdraw';
                    break;
                case 'xfer':
                    reqUrl = 'user_transaction_cancel_xfer';
                    break;
            }

            return Request.make(reqUrl, data).then(function(response) {
                return response.data;
            });

        };

        /**
         * Will skip auto-deposits till set date
         * @param type
         * @param data
         * @returns {*}
         */
        user.skipAutoDeposit = function (date) {
            return Request.make('user_auto_deposit_skip_date', {date: date}).then(function(response) {
                return response.data.dates;
            });
        };


        /**
         * @deprecated
         * @returns {*}
         */
        user.getFundingActivity = function () {
            return user.get('msFundingActivity');
        };
        /**
         * @deprecated
         * @param {Object} filters
         * @param {Array} filters.type
         * @param {Array} filters.status
         * @param {Boolean} refresh
         * @returns {*}
         */
        user.retrieveFundingActivity = function (filters, refresh) {
            if (user.get('msFundingActivity') && !refresh) {
                return $q.when(user.get('msFundingActivity'));
            } else {
                return Request.make("milestone_funding_activity", filters).then(function (response) {
                    var transactions = response.data.transactions;
                    var splitTransactions = {
                        pending: [],
                        complete: []
                    };
                    angular.forEach(transactions, function(transaction) {
                        if (transaction.in_progress === true) {
                            splitTransactions.pending.push(transaction);
                        } else {
                            splitTransactions.complete.push(transaction);
                        }
                    });
                    userData.msFundingActivity = splitTransactions;
                    return userData.msFundingActivity;
                });
            }
        };
        /**
         * @deprecated
         * @param transactions
         * @returns {Array}
         */
        user.formatFundingTableData = function (transactions) {
            var transData = [];
            angular.forEach(transactions, function(trans) {
                var data = {};
                angular.copy(trans, data);

                var transDate = new Date(trans.date);
                //convert time to remove unwanted UTC to current timeaone conversion
                data.date = new Date( transDate.getTime() + ( transDate.getTimezoneOffset() * 60000 ) );

                //sort out type_extra column
                if ("Dividend" === data.type) {
                    data.type_extra = data.type + " - " + data.ticker;
                } else if (data.contribution_year) {
                    data.type_extra = data.contribution_year + " Contribution";
                } else if ("Package" === data.type) {
                    data.type_extra = "Tax Protection";
                } else {
                    data.type_extra = data.type;
                }

                data.milestoneAccount = data.milestone_name + " - " + data.account_description;

                transData.push(data);
            });
            return transData;
        };

        /**
         * @deprecated
         * @returns {*}
         */
        user.getTradeHistory = function () {
            return user.get('tradeHistory');
        };
        /**
         * @deprecated
         * @param refresh
         * @returns {*}
         */
        user.retrieveTradeHistory = function (refresh) {
            if (user.getTradeHistory() && !refresh) {
                return $q.when(user.getTradeHistory());
            } else {
                return Request.make("account_all_trades").then(function (response) {
                    userData.tradeHistory = response.data.trades;
                    if (!userData.tradeHistory) {
                        userData.tradeHistory = [];
                    }
                    return userData.tradeHistory;
                });
            }
        };

        user.getAccounts = function () {
            return user.get('accounts');
        };
        user.retrieveAccounts = function (refresh) {
            if (user.getAccounts() && !refresh) {
                return $q.when(user.getAccounts());
            } else {
                return Request.make("accounts").then(function (response) {
                    userData.accounts = response.data.response.accounts;
                    return userData.accounts;
                });
            }
        };

        user.getBankAccounts = function () {
            return user.get('bankAccounts');
        };
        user.retrieveBankAccounts = function (refresh) {
            if (user.getBankAccounts() && !refresh) {
                return $q.when(user.getBankAccounts());
            } else {
                return Request.make("banks").then(function (response) {
                    userData.bankAccounts = response.data;
                    //
                    // var axosLogo = "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";
                    // var axosPrimary = "#1E3860";
                    //
                    // angular.forEach([userData.bankAccounts.active, userData.bankAccounts.pending], function(bank) {
                    //     if (bank && bank.display) {
                    //         if (!bank.display.logo) {
                    //             bank.display.logo = axosLogo;
                    //         }
                    //         if (bank.display.colors) {
                    //             bank.display.colors.primary = axosPrimary;
                    //         }
                    //     }
                    // });

                    return userData.bank_accounts;
                });
            }
        };

        user.getBankPlaidLogo = function (id) {
            var logos = user.get('bankPlaidLogo');
            if (logos && id) {
                return logos[id];
            } else {
                return logos;
            }
        };
        user.retrieveBankLogo = function (id, refresh) {
            if (user.getBankPlaidLogo(id) && !refresh) {
                return $q.when(user.getBankPlaidLogo(id));
            } else {
                return Request.make("bank_plaid_logo", {institutionId: id}).then(function (response) {
                    userData.bankPlaidLogo || (userData.bankPlaidLogo = {}); // jshint ignore:line

                    userData.bankPlaidLogo[id] = response.data;

                    return userData.bankPlaidLogo[id];
                });
            }
        };

        user.getDocuments = function () {
            return user.get('documents');
        };
        user.retrieveDocuments = function (refresh) {
            if (user.get('documents') && !refresh) {
                return $q.when(user.get('documents'));
            } else {
                return Request.make("user_documents").then(function (response) {
                    userData.documents = response.data.response.documents;
                    return userData.documents;
                });
            }
        };
        user.getDocumentUrl = function (key) {
            //retrieve url for secure documents
            return Request.make("user_document", {
                "key": key
            });
        };
        user.getProspectusLinks = function(ticker) {
            var prospectuses = user.get('prospectus');
            var prospectus = null;
            if (ticker && prospectuses) {
                angular.forEach(prospectuses, function(p) {
                    if (p.ticker === ticker) {
                        prospectus = p;
                    }
                });
                return prospectus;
            } else {
                return prospectuses;
            }
        };
        user.retrieveProspectusLinks = function(refresh) {
            if (user.get('prospectus') && !refresh) {
                return $q.when(user.get('prospectus'));
            } else {
                return Request.make("user_prospectus").then(function (response) {
                    userData.prospectus = response.data.assets;
                    return userData.prospectus;
                });
            }
        };


        user.getDocumentRequests = function () {
            return user.get('documentRequests');
        };
        user.retrieveDocumentRequests = function (refresh) {
            if (user.get('documentRequests') && !refresh) {
                return $q.when(user.get('documentRequests'));
            } else {
                return Request.make("user_document_requests").then(function (response) {
                    userData.documentRequests = response.data;
                    return userData.documentRequests;
                });
            }
        };
        user.submitDocumentRequests = function (uuid) {
            return Request.make("user_document_requests_submit", {uuid: uuid});
        };

        user.deleteUploadedDocument = function (key) {
            return Request.make("user_document_delete", {document: key});
        };
        user.uploadDocuments = function(files = [], data = {}, block = true) {
            var docPromises = [], badFiles = [];

            var url = Request.url('user_documents');
            if (block) {
                url += '?block_email=documentUpload'; //always block email
            }

            angular.forEach(files, function(file, index) {
                var p;
                var uploadData;

                uploadData = angular.copy(data);
                uploadData.file = file;

                file.upload = Upload.upload({
                    url: url,
                    data: uploadData,
                    method: "POST",
                    headers: {
                        "Auth-Token": Auth.getToken(),
                        "x-wisebanyan-app":"desktop",
                        "x-wisebanyan-sig": Auth.getSigKey(),
                        "x-api-key": Auth.getApiKey()
                    }
                });

                p = file.upload.then(function (response) {
                    //yay
                }).catch(function (response) {
                    badFiles.push(file);
                    file.$error = "message";
                    if(response && response.status===413) {
                        file.message = 'it exceeds the file size limit. Please use a smaller file.';
                    } else {
                        file.message = 'try again later or contact us at support@axosinvest.com.';
                    }
                }).finally(function() {
                    //remove each file from the queue when it's done
                    angular.forEach(files, function(fileMatch, index) {
                        if (file === fileMatch) {
                            files.splice(index, 1);
                        }
                    });
                }, function (evt) {
                    //event callback for promise status
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });

                docPromises.push(p);
            });

            return {
                promise: $q.all(docPromises),
                badFiles: badFiles
            };
        };

        user.getReferrals = function () {
            return user.get('referrals');
        };
        user.retrieveReferrals = function (refresh) {
            if (user.get('referrals') && !refresh) {
                return $q.when(user.get('referrals'));
            } else {
                return Request.make("user_referrals").then(function (response) {
                    userData.referrals = response.data;
                    return userData.referrals;
                });
            }
        };
        user.getInvites = function () {
            return user.get('invites');
        };
        user.retrieveInvites = function (refresh) {
            if (user.get('invites') && !refresh) {
                return $q.when(user.get('invites'));
            } else {
                return Request.make("user_invites").then(function (response) {
                    userData.invites = response.data;
                    return userData.invites;
                });
            }
        };
        /**
         * @param {Object} data
         * @param {Array} data.email
         * @param {string} data.alias
         * @returns {*}
         */
        user.makeReferral = function (data) {
            return Request.make("user_refer", data);
        };

        /**
         * @param {Object} data
         * @param {Object} data.fields
         * @param {string} data.fields.key
         * @param {string} data.fields.platform
         * @param {string} data.fields.response
         * @returns {*}
         */
        user.sendFeedback = function (data) {
            return Request.make("user_feedback", data);
        };

        user.closeUser = function (data) {
            Track.send("Closed Account", "Closed Account");

            return Request.make("user_close", {
                answer: data.answer,
                response: data.response
            });
        };

        user.updatePassword = function (old_pass, new_pass) {
            Track.send("Updated Password", "User updated their password");

            return Request.make("user_update_password", {
                oldOne: old_pass,
                newOne: new_pass
            });
        };

        /**
         * @deprecated
         * @param frequency
         */
        user.updateFrequency = function(frequency) {
            return Request.make("user_update_frequency", {
                auto_deposit_frequency: frequency
            });
        };

        user.welcome = function () {
            return Request.make("welcome").then(function(response) {
                return response.data.response;
            });
        };

        user.signAgreement = function (status) {
            var data = { "status": status };
            return Request.make("user_sign", data);
        };

        user.sendVerifyEmail = function () {
            return Request.make("user_send_verify_email");
        };

        user.signupRequest = function(data) {
            return Request.make("signup_request", {
                email_address: data.emailAddress,
                referral_code: data.referralCode,
                alias: data.alias,
                campaign: data.campaign,
                paramHistory: data.paramHistory,
                otp: data.otp,
                reset: data.reset
            });
        };
        user.signupReferralNameRequest = function(referralCode) {
            return Request.make("signup_referral_name", {
                referral_code: referralCode
            }).then(function(response) {
                return response.data.response.first_name;
            });
        };

        /**
         * @param {Object} data
         * @param {string} data.action
         * @param {string} [data.type]
         * @param {string} [data.account_type]
         * @param {string} [data.amount]
         * @param {string} [data.old_auto_amount]
         * @param {string} [data.auto_amount]
         * @returns {*}
         */
        user.getReceipt = function (data) {
            return Request.make("user_receipts", data).then(function(response) {
                return response.data.response.recommendation;
            });
        };

        testData = {
            positions: {
                "yours": {
                    "stocks": {
                        "percent": 30,
                        "your_target": 23,
                        "market_value": 30.77,
                    },
                    "bonds": {
                        "percent": 40,
                        "your_target": 23,
                        "market_value": 30.77,
                    },
                    "cash": {
                        "percent": 30,
                        "your_target": 23,
                        "market_value": 30.77,
                    },
                    "asset_classes": [
                        {
                            "code": "ST2",
                            "name": "QEmerging Markets",
                            "your_target": 34,
                            "percent": 10,
                            "category": "Stock",
                            "market_value": 730.9299999999999,
                            "tickers": [
                                {
                                    "ticker": "VWO",
                                    "ticker_name": "Vanguard FTSE Emerging Markets ETF",
                                    "percent": 4.7,
                                    "price": 43.3,
                                    "market_value": 730.9299999999999,
                                    "total_shares": 16.88064,
                                },
                            ]
                        },
                        {
                            "code": null,
                            "name": "CASHHHH",
                            "your_target": 34,
                            "percent": 30,
                            "category": "Cash",
                            "market_value": 730.9299999999999,
                            "tickers": [
                                {
                                    "ticker": "USD",
                                    "ticker_name": "US Dollars",
                                    "percent": 4.7,
                                    "price": 43.3,
                                    "market_value": 730.9299999999999,
                                    "total_shares": 16.88064,
                                },
                            ]
                        },
                        {
                            "code": "BD2",
                            "name": "WEmerging Markets",
                            "your_target": 34,
                            "percent": 10,
                            "category": "Bond",
                            "market_value": 730.9299999999999,
                        },
                        {
                            "code": "BD1",
                            "name": "WEmerging Markets",
                            "your_target": 34,
                            "percent": 25,
                            "category": "Bond",
                            "market_value": 730.9299999999999,
                            "tickers": [
                                {
                                    "ticker": "VWO",
                                    "ticker_name": "Vanguard FTSE Emerging Markets ETF",
                                    "percent": 4.7,
                                    "price": 43.3,
                                    "market_value": 730.9299999999999,
                                    "total_shares": 16.88064,
                                },
                                {
                                    "ticker": "WWE",
                                    "ticker_name": "World Wrestling Entertainment",
                                    "percent": 4.7,
                                    "price": 43.3,
                                    "market_value": 730.9299999999999,
                                    "total_shares": 16.88064,
                                },
                            ]
                        },
                    ],
                },
                "milestone_accounts": [
                    {
                        "account_number": "2hu3i4hi",
                        "account_name": "Personal Account",
                        "owned_by_client": true,
                        "stocks": {
                            "percent": 0,
                            "your_target": 23,
                            "market_value": 30.77,
                        },
                        "bonds": {
                            "percent": 100,
                            "your_target": 23,
                            "market_value": 30.77,
                        },
                        "cash": {
                            "percent": 0,
                            "your_target": 23,
                            "market_value": 30.77,
                        },
                        "asset_classes": [
                            {
                                "code": "IFF",
                                "name": "Emerging Markets",
                                "your_target": 34,
                                "percent": 100,
                                "category": "Bond",
                                "market_value": 30.77,
                                "tickers": [
                                    {
                                        "ticker": "VWQ",
                                        "ticker_name": "Vanguard FTSE Emerging Markets ETF",
                                        "percent": 4.7,
                                        "price": 43.3,
                                        "market_value": 730.9299999999999,
                                        "total_shares": 16.88064,
                                    },
                                ]
                            },
                        ],
                    },
                ],
            }
        };

        return user;
    }]);
})();
